// VoK MUI helper functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem"; // VoK MUI base styles
import colors from "app/assets/theme-dark/base/colors";
import boxShadows from "app/assets/theme-dark/base/boxShadows";
import borders from "app/assets/theme-dark/base/borders";

const {transparent} = colors;
const {lg} = boxShadows;
const {borderRadius} = borders;

const popover = {
    styleOverrides: {
        paper: {
            backgroundColor: transparent.main,
            boxShadow: lg,
            padding: pxToRem(8),
            borderRadius: borderRadius.lg,
        },
    },
};

export default popover;
